import apiClient from "./apiClient";
import AppError from "../utils/AppError";
import Folder from "../models/Folder";
import {
  showErrorNotification,
  showSuccessNotification,
} from "../utils/notifications";

const FolderService = {
  async getFolders(organisationId) {
    try {
      const { data } = await apiClient.get("/inspections/folders", {
        params: { organisationId, includeRoot: true },
      });
      return Folder.fromServerModel(data.folders);
    } catch (error) {
      const appError = new AppError({
        title: "Failed to Fetch Folders",
        response: error.response,
        userMessage: "Could not retrieve folder list.",
      });
      showErrorNotification(appError);
      throw appError;
    }
  },

  async createFolder({ parentFolderId, folderName, isSewer, standard }) {
    try {
      const payload = {
        parentJob: parentFolderId,
        jobName: folderName,
        pipeTypeSewer: isSewer,
        standardKey: standard,
      };
      await apiClient.post("/inspections/folders", payload);
      showSuccessNotification(
        "Success",
        `Folder "${folderName}" created successfully!`
      );
    } catch (error) {
      console.error("Folder Service Error:", error);
      const appError = new AppError({
        title: "Failed to Create Folder",
        response: error.response,
        userMessage:
          error.response?.data?.nonFieldErrors ||
          "Could not create the folder.",
      });
      showErrorNotification(appError);
      throw appError;
    }
  },

  async renameFolder(folderId, newName) {
    try {
      const payload = { jobName: newName };
      await apiClient.patch(`/inspections/folders/${folderId}`, payload);
      showSuccessNotification("Success", "Folder renamed successfully!");
    } catch (error) {
      console.error("Folder Service Error:", error);
      const appError = new AppError({
        title: "Failed to Rename Folder",
        response: error.response,
        userMessage: "Could not rename the folder.",
      });
      showErrorNotification(appError);
      throw appError;
    }
  },

  async deleteFolder(folderId) {
    try {
      await apiClient.delete(`/inspections/folders/${folderId}`);
      showSuccessNotification("Success", "Folder deleted successfully!");
      return folderId;
    } catch (error) {
      console.error("Folder Service Error:", error);
      const appError = new AppError({
        title: "Failed to Delete Folder",
        response: error.response,
        userMessage:
          error.response?.data?.nonFieldErrors ||
          "Could not delete the folder.",
      });
      showErrorNotification(appError);
      throw appError;
    }
  },

  async moveFolder(folderId, destinationId) {
    try {
      const payload = { destinationFolder: destinationId };
      await apiClient.patch(`/inspections/folders/${folderId}`, payload);
      showSuccessNotification("Success", "Folder moved successfully!");
    } catch (error) {
      console.error("Folder Service Error:", error);
      const appError = new AppError({
        title: "Failed to Move Folder",
        response: error.response,
        userMessage:
          error.response?.data?.nonFieldErrors || "Could not move the folder.",
      });
      showErrorNotification(appError);
      throw appError;
    }
  },
};

export default FolderService;
